import {ViewIdentifiable} from "../../models/common/ViewSettings";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ApiReturnType, getUserViewSettingsApiRequest} from "../../models/common/ApiReturnType";
import {AppState} from "../../reducers/RootReducer";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {eventNotificationError, eventNotificationSuccess} from "../common/EventNotificationActions";
import {
    ContractedWork,
} from "../../models/contractor/ContractedWork";
import {  ofType, StateObservable } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { Observable, of } from 'rxjs';
import {Nullable} from "../../models/common/Nullable";
import {ContractorId} from "../../models/contractor/Contractor";
import {Identifier} from "../../models/common/Identifier";

/**
 * base API path to interact with project roles
 */
function apiPath( contractorId: number, id: Nullable<number> = null ): string {
    return APP_CONFIG.baseWeb + "contractors/"+contractorId+"/works/"+ ( id !== null ? id : '');
}

/** union of all project role actions types */
export type ContractedWorkActionTypes = FetchContractedWorksActionTypes


/**
 * FETCH CONTRACTED_WORKS BY USER VIEW SETTINGS
 *
 * user view settings will automatically be retrieved from redux store
 */
// TYPESCRIPT REDUX ACTION TYPES
export interface FetchContractedWorksAction extends ContractorId, ViewIdentifiable, ReduxAction< typeof FETCH_CONTRACTED_WORKS > {}
export interface FetchContractedWorksSuccessAction extends ContractorId, ViewIdentifiable, ReduxAction<typeof FETCH_CONTRACTED_WORKS_SUCCESS > {
    payload: ApiReturnType< ContractedWork[] >
}
export interface FetchContractedWorksErrorAction extends ContractorId, ViewIdentifiable, ErrorAction< typeof FETCH_CONTRACTED_WORKS_ERROR >{}

export type FetchContractedWorksActionTypes = FetchContractedWorksAction
    | FetchContractedWorksErrorAction
    | FetchContractedWorksSuccessAction

// REDUX ACTION TYPE CONSTANTS
export const FETCH_CONTRACTED_WORKS = "FETCH_CONTRACTED_WORKS";
export const FETCH_CONTRACTED_WORKS_SUCCESS = "FETCH_CONTRACTED_WORKS_SUCCESS";
export const FETCH_CONTRACTED_WORKS_ERROR = "FETCH_CONTRACTED_WORKS_ERROR";

// REDUX ACTION ACCESSORS FUNCTIONS
export function fetchContractedWorks( contractorId: Identifier<number>, viewIdentifier: string ) : FetchContractedWorksAction {
    return { type: FETCH_CONTRACTED_WORKS, viewIdentifier, contractorId };
}
export function fetchContractedWorksSuccess(
    contractorId: Identifier<number>,
    viewIdentifier: string,
    payload: ApiReturnType< ContractedWork[] >
) : FetchContractedWorksSuccessAction
{
    return {
        type: FETCH_CONTRACTED_WORKS_SUCCESS,
        viewIdentifier,
        payload,
        contractorId
    };
}
export function fetchContractedWorksError(
    contractorId: Identifier<number>,
    viewIdentifier: string,
    error: Error
): FetchContractedWorksErrorAction {
    return { type: FETCH_CONTRACTED_WORKS_ERROR, viewIdentifier, error, contractorId };
}

// REDUX OBSERVABLE EPIC
export function fetchContractedWorksEpic(
    action$: Observable< FetchContractedWorksAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( FETCH_CONTRACTED_WORKS ),
        switchMap( action => {
            const request = getUserViewSettingsApiRequest(
                apiPath( action.contractorId.rawValue ),
                action.viewIdentifier,
                store$
            );

            return ajax( APP_CONFIG.getRequestObject(request.path) ).pipe(
                map( response => fetchContractedWorksSuccess(
                    action.contractorId,
                    action.viewIdentifier,
                    response.response as ApiReturnType<ContractedWork[]>
                ) ),
                catchError(error => of(
                    fetchContractedWorksError( action.contractorId, action.viewIdentifier, error),
                    eventNotificationError(error, store$, action.viewIdentifier, "fetchContractedWorks")
                ))
            );

        })
    );
}
